import "./Person.css";

export default function Person({ person }) {
  const { role, name, address, phone, email } = person;

  return (
    <div className="person-card">
      <h2 className="person-role">{role}</h2>
      <p className="person-name">{name}</p>

      <div className="person-info">
        {address && (
          <p>
            <span className="label">Adres:</span> {address}
          </p>
        )}

        <p>
          <span className="label">Telefon:</span>{" "}
          {Array.isArray(phone) ? (
            phone.map((num, index) => (
              <span key={index}>
                <a href={`tel:${num}`} className="person-link">
                  {num}
                </a>
                {index < phone.length - 1 && ", "}
              </span>
            ))
          ) : (
            <a href={`tel:${phone}`} className="person-link">
              {phone}
            </a>
          )}
        </p>

        <p>
          <span className="label">E-mail:</span>{" "}
          <a href={`mailto:${email}`} className="person-link">
            {email}
          </a>
        </p>
      </div>
    </div>
  );
}
